import { Input } from "@/components/ui/input"

interface HistoryFiltersProps {
  searchTerm: string
  setSearchTerm: (value: string) => void
  statusFilter: "all" | "pending" | "sent" | "cancelled" | "used"
  setStatusFilter: (value: "all" | "pending" | "sent" | "cancelled" | "used") => void
}

export function HistoryFilters({ 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter 
}: HistoryFiltersProps) {
  return (
    <div className="flex gap-4 mb-6">
      <Input
        placeholder="Rechercher par nom du client ou de la clé..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="max-w-sm"
      />
      <select
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value as "all" | "pending" | "sent" | "cancelled" | "used")}
        className="border rounded-md px-3 py-2"
      >
        <option value="all">Tous les statuts</option>
        <option value="pending">En attente</option>
        <option value="sent">Envoyés</option>
        <option value="cancelled">Annulés</option>
        <option value="used">Utilisés</option>
      </select>
    </div>
  )
}